import { Injectable } from '@angular/core';
import { Roles } from '@fitness-force/enum';

export interface UserDetails {
  role: string | number;
  single_staff_discount?: number;
  Id?: number;
}

@Injectable({
  providedIn: 'root',
})
export class FreezePermissionService {
  /**
   * Check whether the user is an admin
   */
  isAdmin(userDetails: UserDetails): boolean {
    const role = userDetails.role;
    return (
      (typeof role === 'string' && role.toLowerCase() === 'admin') ||
      role === Roles.Admin ||
      role.toString() === Roles[Roles.Admin]
    );
  }

  /**
   * Check whether the user is a staff member (non-admin)
   */
  isStaff(userDetails: UserDetails): boolean {
    const role = userDetails.role;
    return (
      role === Roles.Staff ||
      (typeof role === 'string' && role.toLowerCase() === 'staff') ||
      role.toString() === Roles[Roles.Staff]
    );
  }

  /**
   * Determine if the user has freeze approval rights (admin)
   */
  hasApprovalRights(userDetails: UserDetails): boolean {
    return this.isAdmin(userDetails);
  }

  /**
   * Determine if payment buttons should be shown
   */
  canShowPaymentButtons(options: {
    mode: string;
    isPaymentRequired: boolean;
    userDetails: UserDetails;
  }): boolean {
    const { mode, isPaymentRequired, userDetails } = options;
    if (mode === 'request') {
      return this.isAdmin(userDetails) && isPaymentRequired;
    }
    return isPaymentRequired && (mode === 'freeze' || mode === 'approve');
  }

  /**
   * Determine if the primary submit button should be shown
   */
  canShowSubmitButton(options: {
    mode: string;
    isPaymentRequired: boolean;
    userDetails: UserDetails;
  }): boolean {
    const { mode, isPaymentRequired, userDetails } = options;
    if (mode === 'request') {
      return this.isStaff(userDetails) || !isPaymentRequired;
    }
    return !isPaymentRequired;
  }
}
